import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

// lodash
import map from 'lodash/map';

// awesome styled grid
import { Row } from '@zillow/zrs-comet';

// selectors
import { AppSelectors, UserSelectors } from 'app/shared/selectors';

// components
import PropertyCard from 'app/shared/components/soh/PropertyCard';

// styles
import { StyledCol } from './StyledComponents';

const PropertiesViewGrid = (props) => {
    const {
        listings,
    } = props;

    return (
        <Row
            className="PropertiesViewGrid"
        >
            {
                map(listings, (listingModel, index) => {
                    const {
                        feedListingId,
                    } = listingModel;

                    return (
                        <StyledCol
                            className="PropertiesDisplay-StyledCol"
                            xs={12}
                            lg={6}
                            xl={4}
                            key={index}
                        >
                            <LazyLoad
                                height={262}
                                once={true}
                            >
                                <PropertyCard
                                    key={feedListingId}
                                    listing={listingModel}
                                />
                            </LazyLoad>
                        </StyledCol>
                    );
                })
            }
        </Row>
    );
};

PropertiesViewGrid.propTypes = {
    listings: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
    user: UserSelectors.makeUser(state),
    cookieEnabledServices: AppSelectors.makeCookieEnabledServices(state),
});

export { PropertiesViewGrid };
export default connect(mapStateToProps)(PropertiesViewGrid);
